/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

export const SubmissionBoundaryOrderFieldViewer = (props) => {
    const {Value: submissionBoundaryOrder} = props;

    if (submissionBoundaryOrder == null) {
        return "Answers not reviewed by internal staff";
    }

    if (Number(submissionBoundaryOrder) === 0) {
        return "Answers provided by and reviewed entirely by internal staff";
    }

    return "Answers reviewed and finalized by internal staff";
};
